import { createContext, useContext } from "react";

export interface ImageLightboxImage {
  alt: string;
  id: string;
  src: string;
}

export interface ImageLightboxContextValue {
  openImageLightbox: (
    images: ImageLightboxImage[],
    initialImageId: string,
    onImageView?: (imageId: string, operationId: string) => void,
  ) => void;
}

export const ImageLightboxContext = createContext<ImageLightboxContextValue | null>(null);

export function useImageLightbox() {
  const context = useContext(ImageLightboxContext);

  if (!context) {
    throw new Error("useImageLightbox 必须在 ImageLightboxProvider 内使用");
  }

  return context;
}
